import { Color, Text } from '@billy/design-system'
import type { TextWeight } from '@billy/design-system'
import { Tooltip } from '@shinetools/lumen-react'
import { ReactElement } from 'react'

import { useIsTruncated } from '../../../../hooks'

interface TruncatedTextCellProps {
  color?: Color
  value: string
  weight?: TextWeight
}

export const TruncatedTextCell = ({ color, value, weight }: TruncatedTextCellProps): ReactElement => {
  const [textRef, isTruncated] = useIsTruncated(value)

  const textElement = (
    <Text ref={textRef} color={color} truncate weight={weight}>
      {value}
    </Text>
  )

  return isTruncated ? (
    <Tooltip label={value} placement="top">
      {textElement}
    </Tooltip>
  ) : (
    textElement
  )
}
